import { en } from './en';
import { es } from './es';
import { fr } from './fr';
import { he } from './he';
import { zh } from './zh';

// All available translations
export const translations = {
  en,
  es,
  fr,
  he,
  zh
};

// Get translation object for a specific language
export const getTranslations = (languageCode) => {
  return translations[languageCode] || translations.en; // Default to English
};

// Get a specific translation key for a language
export const t = (languageCode, key) => {
  const translation = getTranslations(languageCode);
  return translation[key] || key; // Return key if translation not found
};

// Available languages
export const availableLanguages = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'he', name: 'Hebrew', nativeName: 'עברית' },
  { code: 'zh', name: 'Mandarin', nativeName: '中文' },
  { code: 'ko', name: 'Korean', nativeName: '한국어' }
];